import { render, staticRenderFns } from "./no-valid-scores-available.vue?vue&type=template&id=06265017"
import script from "./no-valid-scores-available.vue?vue&type=script&lang=js"
export * from "./no-valid-scores-available.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports